import createIcon from '../../createIcon';

/**
 * @component @name BubbleChart
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNy4yIDE3LjZDOC45NjczMSAxNy42IDEwLjQgMTYuMTY3MyAxMC40IDE0LjRDMTAuNCAxMi42MzI3IDguOTY3MzEgMTEuMiA3LjIgMTEuMkM1LjQzMjY5IDExLjIgNCAxMi42MzI3IDQgMTQuNEM0IDE2LjE2NzMgNS40MzI2OSAxNy42IDcuMiAxNy42WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTE0LjggMjBDMTUuOTA0NiAyMCAxNi44IDE5LjEwNDYgMTYuOCAxOEMxNi44IDE2Ljg5NTQgMTUuOTA0NiAxNiAxNC44IDE2QzEzLjY5NTQgMTYgMTIuOCAxNi44OTU0IDEyLjggMThDMTIuOCAxOS4xMDQ2IDEzLjY5NTQgMjAgMTQuOCAyMFoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xNS4yIDEzLjZDMTcuODUxIDEzLjYgMjAgMTEuNDUxIDIwIDguOEMyMCA2LjE0OTAzIDE3Ljg1MSA0IDE1LjIgNEMxMi41NDkgNCAxMC40IDYuMTQ5MDMgMTAuNCA4LjhDMTAuNCAxMS40NTEgMTIuNTQ5IDEzLjYgMTUuMiAxMy42WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const BubbleChart = createIcon('BubbleChart', [
  [
    'path',
    {
      d: 'M7.2 17.6C8.96731 17.6 10.4 16.1673 10.4 14.4C10.4 12.6327 8.96731 11.2 7.2 11.2C5.43269 11.2 4 12.6327 4 14.4C4 16.1673 5.43269 17.6 7.2 17.6Z',
      key: 'f9m5u3',
    },
  ],
  [
    'path',
    {
      d: 'M14.8 20C15.9046 20 16.8 19.1046 16.8 18C16.8 16.8954 15.9046 16 14.8 16C13.6954 16 12.8 16.8954 12.8 18C12.8 19.1046 13.6954 20 14.8 20Z',
      key: '26yewz',
    },
  ],
  [
    'path',
    {
      d: 'M15.2 13.6C17.851 13.6 20 11.451 20 8.8C20 6.14903 17.851 4 15.2 4C12.549 4 10.4 6.14903 10.4 8.8C10.4 11.451 12.549 13.6 15.2 13.6Z',
      key: 'dj17k6',
    },
  ],
]);

export default BubbleChart;
